var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKiss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM15 12C14.4477 12 14 11.3284 14 10.5C14 9.67157 14.4477 9 15 9C15.5523 9 16 9.67157 16 10.5C16 11.3284 15.5523 12 15 12ZM10 10.5C10 11.3284 9.55229 12 9 12C8.44771 12 8 11.3284 8 10.5C8 9.67157 8.44771 9 9 9C9.55229 9 10 9.67157 10 10.5ZM12.307 13.7136C12.4652 13.3308 12.9037 13.1486 13.2866 13.3068L15.0279 14.0261C15.9212 14.3952 16.0072 15.6273 15.1672 16.1131L14.6925 16.3876L15.0279 16.5261C15.9212 16.8952 16.0072 18.1273 15.1672 18.6131L13.3757 19.6492C13.0171 19.8566 12.5583 19.734 12.351 19.3754C12.1436 19.0169 12.2661 18.5581 12.6247 18.3507L13.8294 17.654L13.494 17.5154C12.6007 17.1464 12.5147 15.9143 13.3548 15.4285L13.8294 15.154L12.7138 14.6931C12.331 14.535 12.1489 14.0964 12.307 13.7136Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiss);
export default __webpack_public_path__ + "static/media/kiss.4f97736b6bd9aec63fffc96f588ead28.svg";
export { ForwardRef as ReactComponent };